import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TitleCard from '@/components/utils/TitleCard.vue';
import BaseArticle from '@/components/Works/baseArticle.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MuseumView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_q_video = _resolveComponent("q-video")!

  return (_openBlock(), _createBlock(BaseArticle, {
    "product-name": "マイクラ博物館の謎",
    imgsrc: require('@/assets/Home/museum.png')
  }, {
    default: _withCtx(() => [
      _createVNode(TitleCard, {
        title: "マインクラフト × 謎解き！",
        abst: [
        'マインクラフトの全てが展示されている博物館。',
        'そこに迷い込んだあなたは一人の少女と出会う。',
        '「お願い、博物館の時間を動かしたいの！」',
        'どうやら博物館の時間が止まってしまったらしい。',
        'なぜ時間が止まってしまったのか？',
        'そもそもマイクラ博物館とは何なのか？',
        'ラナと呼ばれる少女と共に、博物館の謎を解き明かせ！',
      ]
      }),
      _createVNode(TitleCard, { title: "1stPV" }, {
        abst: _withCtx(() => [
          _createVNode(_component_q_video, {
            src: "https://www.youtube.com/embed/EYcTYiIgwIs",
            class: "innerAssets"
          })
        ]),
        _: 1
      }),
      _createVNode(TitleCard, { title: "続報をお楽しみに！" })
    ]),
    _: 1
  }, 8, ["imgsrc"]))
}
}

})